export function createHelpCenterArticleUrl(articleId: number) {
  /**
   * Using `-` as a url since the correct page will still render.
   * Eventually backend will provide the full url e.g. /h/my-account/q-1234,
   * but this will do for now as url slugification with locale introduces too much complexity for this
   * use case at the moment
   */
  return `/h/-/q-${articleId}`;
}
